import ModalText from './ModalText'


export default ModalText